import request from '@/utils/request'; // 游泳订单列表（独立接口，只查游泳订单）

export function fetchSwimmingOrderList(data) {
  return request({
    url: '/whg-park/api/order/swimmingList',
    method: 'post',
    data: data
  });
} // 游泳订单详情

export function fetchSwimmingOrderDetail(data) {
  return request({
    url: '/whg-park/api/order/get',
    method: 'post',
    data: data
  });
} // 退款（只改状态）

export function refundAdmin(data) {
  return request({
    url: '/whg-park/api/activityItem/refundAdmin',
    method: 'post',
    data: data
  });
} // 单次核销

export function activeWriteOff(data) {
  return request({
    url: '/whg-park/api/activityItem/activeWriteOff',
    method: 'post',
    data: data
  });
} // 一键全部核销

export function activeWriteOffAll(data) {
  return request({
    url: '/whg-park/api/activityItem/activeWriteOffAll',
    method: 'post',
    data: data
  });
} // 退款（钱会退回）

export function refund(data) {
  return request({
    url: '/wechat/api/wxPay/refund',
    method: 'post',
    data: data
  });
}